import { isoDayIn } from '@fluxus/shared';

/**
 * Horário das reuniões no fuso da plataforma (o mesmo das datas da aplicação — America/Sao_Paulo, sem horário de
 * verão desde 2019): o dia no calendário, os campos de data e hora do formulário e o mês pedido à API.
 */
export const MEETING_TIME_ZONE = 'America/Sao_Paulo';
const OFFSET = '-03:00';

const timeFormat = new Intl.DateTimeFormat('pt-BR', {
  timeZone: MEETING_TIME_ZONE,
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23',
});

/** Dia ("AAAA-MM-DD") e hora ("HH:MM") do início, no fuso da plataforma. */
export function localParts(iso: string): { day: string; time: string } {
  const date = new Date(iso);
  return { day: isoDayIn(MEETING_TIME_ZONE, date), time: timeFormat.format(date) };
}

/** Data e hora digitadas (no fuso da plataforma) → instante com fuso para a API. */
export const startsAtFrom = (day: string, time: string) => `${day}T${time}:00.000${OFFSET}`;

/** Mês (1–12) → início (inclusive) e fim (exclusive) para o filtro de período da API. */
export function monthRange(year: number, month: number): { from: string; to: string } {
  const pad = (n: number) => String(n).padStart(2, '0');
  const next = month === 12 ? { y: year + 1, m: 1 } : { y: year, m: month + 1 };
  return {
    from: `${year}-${pad(month)}-01T00:00:00.000${OFFSET}`,
    to: `${next.y}-${pad(next.m)}-01T00:00:00.000${OFFSET}`,
  };
}

/** Dias do mês num quadro de semanas (segunda a domingo), com os dias de fora do mês como null. */
export function monthGrid(year: number, month: number): (string | null)[][] {
  const pad = (n: number) => String(n).padStart(2, '0');
  const first = new Date(Date.UTC(year, month - 1, 1));
  const days = new Date(Date.UTC(year, month, 0)).getUTCDate();
  const lead = (first.getUTCDay() + 6) % 7; // segunda = 0
  const cells: (string | null)[] = [
    ...Array.from({ length: lead }, () => null),
    ...Array.from({ length: days }, (_, i) => `${year}-${pad(month)}-${pad(i + 1)}`),
  ];
  while (cells.length % 7) cells.push(null);
  const weeks: (string | null)[][] = [];
  for (let i = 0; i < cells.length; i += 7) weeks.push(cells.slice(i, i + 7));
  return weeks;
}

export const MONTH_NAMES = [
  'janeiro',
  'fevereiro',
  'março',
  'abril',
  'maio',
  'junho',
  'julho',
  'agosto',
  'setembro',
  'outubro',
  'novembro',
  'dezembro',
];
export const WEEKDAYS = ['Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb', 'Dom'];
